import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { BankInstitutionComponent } from './../bankinstitution/bankinstitution.component';

import { BankInstitution } from 'app/shared/models/bank-institution.model';

import { FinanceService } from 'app/finance/finance.service';

@Component({
    selector: 'app-bankinstitution-list',
    templateUrl: './bankinstitution-list.component.html'
})

/**
 * Component to display the Bank Institutions list.
 */
export class BankInstitutionListComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    bankInstitutions: BankInstitution[];
    selectedBankInstitution: BankInstitution;
    isBanktListLoaded = false;

    constructor(
        private dialog: MdDialog,
        private financeService: FinanceService,
        private viewContainerRef: ViewContainerRef,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    // Model value for list.
    @Input() status: String;

    ngOnInit() {
        this.updateBankInstitutionsList();
    }

    editBankInstitution(selectedBankInstitution: BankInstitutionComponent): void {
        const action = 'Edit';
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(BankInstitutionComponent, config);
        this.dialogRef.componentInstance.selectedBankInstitution = selectedBankInstitution;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(response => {
            this.dialogRef = null;
            if (response) {
                this.updateBankInstitutionsList();
            }
            this.selectedBankInstitution = null;
        });
    }

    deleteBankInstitution(bankInstitution: BankInstitution) {
        if (confirm(MessageService.DELETE_BANK_INSTITUTION_ALERT)) {
            this.financeService.deleteBankInstitution(bankInstitution.bankId)
                .subscribe(response => {
                    if (response.flagResult) {
                        this.bankInstitutions.splice(this.bankInstitutions.indexOf(bankInstitution), 1);
                    }
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.BANK_INSTITUTIONS,
                        TrackingConstants.DELETE_BANK_INSTITUTION,
                        TrackingConstants.SUCCESS, 1);
                    this.callSnackBarService(response,
                        MessageService.DELETE_BANK_INSTITUTION_SUCCESS, MessageService.DELETE_BANK_INSTITUTION_FAILURE);
                },
                err => {
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.BANK_INSTITUTIONS,
                        TrackingConstants.DELETE_BANK_INSTITUTION,
                        TrackingConstants.FAILURE, 0);
                    this.callSnackBarService(err,
                        MessageService.DELETE_BANK_INSTITUTION_SUCCESS,
                        MessageService.DELETE_BANK_INSTITUTION_FAILURE);
                });
        }
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }

    updateBankInstitutionsList() {
        this.financeService.getBankInstitutionsList()
            .subscribe(bankInstitutions => {
                this.isBanktListLoaded = true;
                this.bankInstitutions = bankInstitutions; 
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/finance/bankinstitutions/bankinstitutionlist/bankinstitution-list.component.ts